import { BookingClient } from "commonModule/services/client"
import { defaultAxiosInstance } from "services/client"

export const apiBookingClient = new BookingClient(defaultAxiosInstance)
